module.exports = __webpack_public_path__ + "img/course_tensorflow.dd05c119.jpg";